import React, { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../app/store";
import { DraftFMR1Fields, selectFMR1DraftFmrFields, updateFMR1DraftField } from "../../../logic/frm1Slice";
import FmrTwoColumnTable, { FmrTwoColumnTableRowProps } from "../common/fmrTwoColumnTable";

export const PART1_TABLE3_ROWS: Array<FmrTwoColumnTableRowProps<DraftFMR1Fields>> = [
  {
    label: "Table 3: FMR - Consortium table",
    kind: "section",
  },
  {
    label: "Particulars",
    rightSectionLabel: "Consortium/MBA Member Amount**",
    kind: "section",
  },
  {
    label: "Consortium Advance",
    key: "consortium_advance",
    type: "number",
  },
];

export interface FMR1Table3FormProps {
  leftWidthPx?: number;
}

const FMR1Table3Form: React.FC<FMR1Table3FormProps> = ({ leftWidthPx }) => {
  const { id: case_id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const draftFields = useAppSelector(selectFMR1DraftFmrFields);

  const handleFieldChange = useCallback((key: keyof DraftFMR1Fields, value: any) => {
    if (!case_id) return;
    dispatch(updateFMR1DraftField({ key: key as keyof DraftFMR1Fields, value }));
  }, [case_id, dispatch]);

  return (
    <FmrTwoColumnTable<DraftFMR1Fields>
      data={draftFields}
      onChange={handleFieldChange}
      rows={PART1_TABLE3_ROWS}
      leftWidthPx={leftWidthPx ?? 435}
      rowHeightPx={44}
      className="overflow-visible"
    />
  );
};

FMR1Table3Form.displayName = "FMR1Table3Form";

export default FMR1Table3Form;
